//Desktop and Mobile Main parent Item links Script Start//
document.addEventListener('DOMContentLoaded', function() {
  const parentSummaries = document.querySelectorAll('summary[data-link]');

  parentSummaries.forEach(summary => {
    summary.addEventListener('click', function(e) {
      const link = summary.dataset.link;

      // Ignore clicks on caret (SVG)
      if (e.target.closest('svg')) return;

      // If link is '#' → just toggle dropdown (don’t redirect)
      if (link === '#') {
        e.preventDefault();
        e.stopPropagation();
        summary.parentElement.toggleAttribute('open');
        return;
      }

      // Otherwise → redirect to link
      e.preventDefault();
      e.stopPropagation();
      window.location.href = link;
    });
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const mobileMenu = document.querySelector('.mobile-menu-drawer');
  if (!mobileMenu) return;

  const parentSummaries = mobileMenu.querySelectorAll('summary[data-link]');

  parentSummaries.forEach(summary => {
    summary.addEventListener('click', function(e) {
      const link = summary.dataset.link;
      if (!link) return;

      // If click is on arrow/caret, open submenu normally
      if (e.target.closest('.menu-drawer__toggle-arrow')) return;

      // Otherwise, redirect to parent link
      e.preventDefault();
      e.stopPropagation();
      window.location.href = link;
    });
  });
});

//Desktop and Mobile Main parent Item links Script close//

jQuery(document).ready(function($){

  function updateLabels() {
    // Change Year labels
    $('.product-form__input.Years label.form__label, .product-form__input.Year label.form__label').text('Select Year:');
    // Change Thickness label
    $('.product-form__input.Thickness legend.form__label').text('Select Thickness:');
  }

  // Initial update
  updateLabels();

  // Reapply every 200ms to catch dynamic updates
  setInterval(updateLabels, 200);

});

jQuery(document).ready(function($){
  setTimeout(function(){
    $('.mmy-year .gv-sel-label').text('Select Year');
    $('.mmy-make .gv-sel-label').text('Select Make');
    $('.mmy-model .gv-sel-label').text('Select Model');
  }, 500); // adjust time if needed
});

jQuery(document).ready(function(){
  jQuery(".tab-btn").click(function(){
    var id_tab = jQuery(this).attr("data-val");
    // Remove 'active' class from all tab buttons and add to the clicked one
    jQuery(".tab-btn").removeClass("active");
    jQuery(this).addClass("active");
    // Remove 'active' class from all tab bodies and add to the target one
    jQuery(".product-tab-body").removeClass("active");
    jQuery(".product-tab-body." + id_tab).addClass("active");
  });
});


// logo Slider Script

	$('.autoplay').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 1500,
  arrows: false,
  dots: false,
  pauseOnHover: false,
  centerMode: false,
  variableWidth: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false
      }
    }
  ]
});

$(document).on('setPosition', '.logo_section .slick-slider', function() {
  // sabko reset karo
  $('.logo_section .slick-slide').css('border-right', '1px solid #ddd');

  // jo last active item hai uska border-right none
  $('.logo_section .slick-slide.slick-active').last().css('border-right', '1px solid transparent ');

  // jo first active item hai, uske previous ka border none
  $('.logo_section .slick-slide.slick-active').first().prev('.slick-slide').css('border-right', '1px solid transparent' );
  // $('.logo_section .slick-slide.slick-active').last().next('.slick-slide').css('padding-left', '0');
});



// home collection slider 

jQuery(document).ready(function($) {
  var $slider = $('.collection_slider');

  $slider.slick({
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,           
    autoplaySpeed: 3500,
    prevArrow: null,
    nextArrow: null,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1, infinite: true, dots: true } },
      { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
  });

  // Custom buttons
  $('.custom-next').on('click', function() {
    $slider.slick('slickNext');
  });

  $('.custom-prev').on('click', function() {
    $slider.slick('slickPrev');
  });

});


// Faq  JS Start
$(document).on("click",".faq-tab-btn",function(){
  var id_tab=$(this).attr("data-val");
  $(".faq-tab-btn").removeClass("active");
  $(this).addClass("active");
  
  $(".tab-body").removeClass("active");
  $(".tab-body."+id_tab).addClass("active");
});


 $(document).ready(function () {
 jQuery(".common-faq-area .accordion-heading").click(function(e){
      if(!$(this).closest(".accordion-box").hasClass("open"))
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
      $(this).closest(".accordion-box").find(".accordion_body").slideToggle();
      $(this).closest(".accordion-box").toggleClass("open");
    }
    else
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
    }
  });
});

// Faq  JS END

// Blog Slider Start


$(document).ready(function () {

  $('.blog-slider').slick({
  dots: false,
  arrows: true, // ✅ enable arrows
  // autoplay:true,
  arrows: true,
  speed: 300,
  infinite: true, 
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
  });





  // Blog Slider End


  // You tube video slider start 

//   jQuery(document).ready(function($) {
//   var $slider = $('.yt_video_slider');

//   $slider.slick({
//     centerMode: true,
//     centerPadding: '200px', // adjust spacing left/right
//     slidesToShow: 3,
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToScroll: 1,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3,
//           centerPadding: '40px',
//         }
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//           centerPadding: '20px',
//         }
//       }
//     ]
//   });

//   // Custom buttons
//   $('.video-next').on('click', function() {
//     $slider.slick('slickNext');
//   });

//   $('.video-prev').on('click', function() {
//     $slider.slick('slickPrev');
//   });

// });


jQuery(document).ready(function($) {
  var $slider = $('.yt_video_slider');

  $slider.slick({
    centerMode: true,
    centerPadding: '200px',
    slidesToShow: 3,
    autoplay:true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 3,
          centerPadding: '40px',
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: '40px',
        }
      }
    ]
  });

  // Custom buttons
  $('.video-next').on('click', function() {
    $slider.slick('slickNext');
  });

  $('.video-prev').on('click', function() {
    $slider.slick('slickPrev');
  });

  // ---- PAUSE all YouTube videos except center ----
  function pauseOtherVideos() {
    var $allIframes = $slider.find('iframe');
    var $centerIframe = $slider.find('.slick-center iframe');

    $allIframes.each(function() {
      if (!$(this).is($centerIframe)) {
        // Send pause command
        this.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          '*'
        );
      }
    });
  }

  // When slide changes
  $slider.on('afterChange', function() {
    pauseOtherVideos();
  });

  // Run once on load
  pauseOtherVideos();
});




  // video slider end


		$(document).ready(function () {
			$('.counter-value').each(function () {
				var $this = $(this);
				var from = parseInt($this.data('from'));
				var to = parseInt($this.data('to'));
				var addPlus = $this.data('plus') == true || $this.data('plus') == "true";
				var leading = $this.data('leading') == true || $this.data('leading') == "true";
				var speed = 2000;

				$({ Counter: from }).animate({ Counter: to }, {
					duration: speed,
					easing: 'swing',
					step: function () {
						let val = Math.ceil(this.Counter);
						if (leading && val < 10) { val = '0' + val; } // sirf jisme data-leading="true" ho
						$this.text(val + (addPlus ? '+' : ''));
					},
					complete: function () {
						let val = this.Counter;
						if (leading && val < 10) { val = '0' + val; }
						$this.text(val + (addPlus ? '+' : ''));
					}
				});
			});
		});



    // Testimonial slider script



    // Hide 6 mil Js Start
// (function () {
//   const launchDate = new Date("2026-02-02T00:00:00"); 
//   const optionValue = "6 mil";

//   function hideSixMil() {
//     const now = new Date();

    
//     if (now >= launchDate) return;

    
//     document.querySelectorAll(`input[type="radio"][value="${optionValue}"]`).forEach(input => {
//       const label = document.querySelector(`label[for="${input.id}"]`);
//       if (label) label.style.display = "none";
//       input.style.display = "none";
//       input.checked = false;
//     });
//   }

  
//   document.addEventListener("DOMContentLoaded", hideSixMil);

  
//   document.addEventListener("variant:change", hideSixMil);

 
//   const observer = new MutationObserver(hideSixMil);
//   observer.observe(document.body, { childList: true, subtree: true });
// })();

// Hide 6 mil Js End
